<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-statistics">
            <div class="statistics-header">
              <h3 class="title">
                <div class="item">
                  기간별 가동률
                </div>
              </h3>
            </div>
            <div class="statistics-body">
              <div class="form">
                <div class="contain">
                  <div class="select">
                    <div class="formSelect" ref="select02">
                      <div class="formSelectList" @click="openSelect02">
                        <input type="text" v-model="locationName" placeholder="지역" readonly />
                      </div>
                      <div class="formSelectPopup select02">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="지역을 선택하세요." />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="locations in locationArr" :key="locations.name">
                                      <label>
                                        <input type="radio" v-model="selectedLocation" :value="locations.code" v-on:change="confirmSelect02()"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{locations.name}}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="calendar">
                    <div class="formCalendar">
                      <div class="formCalendarList">
                        <date-picker
                          v-model="dateRange"
                          type="date" range
                          :format="'YYYY-MM-DD'"
                          :clearable="false"
                          @change="updateValues"
                        >
                          <template v-slot:footer="{ emit }">
                            <div style="text-align: left">
                              <button class="mx-btn mx-btn-text" @click="setSearchPeriod(1, emit)">
                                1개월
                              </button>
                              <button class="mx-btn mx-btn-text" @click="setSearchPeriod(3, emit)">
                                3개월
                              </button>
                            </div>
                          </template>
                        </date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="statistics utilRatio">
                <li>
                  <div class="contain">
                    <div class="header">
                      {{this.locationName}} APL 상태 현황
                    </div>
                    <div class="body">
                      <div class="graph">
                        <BarLineMixedChart v-if="barLineChartLoaded" :chartData="barLineChartData" :options="barLineChartOptions" style="height: 100%;"></BarLineMixedChart>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="statisticsData">
                <!-- 데이터 없을때(Class) : none -->
                <div class="body">
                  <div class="table thead">
                    <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                    <div class="fixed" style="margin-left: -0px;">
                      <div class="excel" @click="downloadExcel">
                        다운로드
                      </div>
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                          </colgroup>
                          <thead>
                          <tr>
                            <th class="sort updateAt" @click="headerSort('updateAt')">
                              <div class="item">
                                날짜
                              </div>
                            </th>
                            <th class="sort allClubCount" @click="headerSort('allClubCount')">
                              <div class="item">
                                전체
                              </div>
                            </th>
                            <th class="sort normalCount" @click="headerSort('normalCount')">
                              <div class="item">
                                정상
                              </div>
                            </th>
                            <th class="sort abnormalCount" @click="headerSort('abnormalCount')">
                              <div class="item">
                                비정상
                              </div>
                            </th>
                            <th class="sort normalPercentage" @click="headerSort('normalPercentage')">
                              <div class="item">
                                정상 가동률
                              </div>
                            </th>
                          </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="table tbody">
                    <div class="contain">
                      <table>
                        <colgroup>
                          <col />
                          <col />
                          <col />
                          <col />
                          <col />
                        </colgroup>
                        <tbody>
                        <tr v-for="stat in sortedComputedUtilRatioStat" :key="stat.updateAt">
                          <td>
                            {{ stat.updateAt }}
                          </td>
                          <td>
                            {{ stat.allClubCount }}
                          </td>
                          <td>
                            {{ stat.normalCount }}
                          </td>
                          <td>
                            {{ stat.abnormalCount }}
                          </td>
                          <td>
                            {{ stat.normalPercentage }}%
                          </td>
                        </tr>
                        </tbody>
                        <tbody class="none">
                        <tr>
                          <td colspan="5" class="read-only">
                            데이터가 없습니다.
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div id="indicatorContainer" v-if="showLoader">
        <svg id="indicator" viewBox="0 0 100 100">
          <circle id="circle" cx="50" cy="50" r="45"></circle>
        </svg>
      </div>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertMessage">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm" @click="closeAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="locations in locationArr" :key="locations.name">
                      <label>
                        <input type="radio" v-model="selectedLocation" :value="locations.code" @change="confirmSelect02"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{locations.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {ammService} from '../../router'

import Colors from 'nice-color-palettes'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import BarLineMixedChart from '../../util/BarLineMixedChart'

const exportExcel = () => import('../../util/excel')

export default {
  name: 'ST001',
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker,
    BarLineMixedChart
  },
  data () {
    return {
      sortColumn: '',
      sortType: '',
      dateRange: [new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()],
      barLineChartLoaded: false,
      barLineChartData: {
        labels: [],
        datasets: []
      },
      barLineChartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              id: 'left',
              type: 'linear',
              position: 'left',
              stacked: true,
              ticks: {
                beginAtZero: true
              }
            },
            {
              id: 'right',
              type: 'linear',
              position: 'right',
              ticks: {
                min: 0,
                max: 100,
                stepSize: 20,
                callback: value => value + '%'
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      utilRatioData: {
        aplStatsClub: [],
        clubInfoList: []
      },
      utilRatioDataSortByRegion: null,
      selectedLocation: '0',
      locationArr: [
        {name: '전국', code: '0'},
        {name: '경기도/인천', code: '1'},
        {name: '충청북도', code: '10'},
        {name: '충청남도', code: '11'},
        {name: '전라도', code: '20'},
        {name: '경상북도', code: '30'},
        {name: '경상남도', code: '31'},
        {name: '강원도', code: '40'},
        {name: '제주도', code: '50'}
      ],
      showLoader: false
    }
  },
  mounted: function () {
    this.setData()
  },
  methods: {
    setData: function () {
      this.showLoader = true
      ammService.getStatisticsUtilRatioData(moment(this.dateRange[0]).format('YYYY-MM-DD'), moment(this.dateRange[1]).format('YYYY-MM-DD')).then(response => {
        this.utilRatioData = response.data
        this.utilRatioDataSortByRegion = this.utilRatioData.aplStatsClub.reduce((acc, curr) => {
          const target = this.utilRatioData.clubInfoList.find(club => club.ccode == curr.ccode)
          if (!target) return acc
          const regionCode = this.setRegionCode(target.ccode, target.region_code)
          const updateAt = moment(curr.updateAt).format('YYYY-MM-DD')
          if (!acc[updateAt]) {
            acc[updateAt] = {}
          }
          if (!acc[updateAt][regionCode]) {
            acc[updateAt][regionCode] = {
              allClubCount: 0,
              normalCount: 0
            }
          }
          acc[updateAt][regionCode].allClubCount += 1
          if (curr.isNormal) acc[updateAt][regionCode].normalCount += 1
          return acc
        }, {})
        this.setChartData()
      }).catch(error => {
        console.log('getStatisticsData.err.===>', error)
      }).finally(() => {
        this.showLoader = false
      })
    },
    setBarLineChart: function () {
      this.barLineChartLoaded = false
      this.barLineChartData = {
        labels: this.computedUtilRatioStat.map(stat => stat.updateAt),
        datasets: [
          {
            label: '가동률',
            type: 'line',
            data: this.computedUtilRatioStat.map(stat => stat.normalPercentage),
            backgroundColor: Colors[2].concat(Colors[7])[2],
            borderColor: Colors[2].concat(Colors[7])[2],
            yAxisID: 'right',
            fill: false
          },
          {
            label: '정상',
            data: this.computedUtilRatioStat.map(stat => stat.normalCount),
            backgroundColor: 'rgba(255, 145, 15, 0.5)',
            yAxisID: 'left',
            stack: 'stack1'
          },
          {
            label: '비정상',
            data: this.computedUtilRatioStat.map(stat => stat.abnormalCount),
            backgroundColor: 'rgba(255, 201, 15, 0.5)',
            yAxisID: 'left',
            stack: 'stack1'
          }
        ]
      }
      this.barLineChartLoaded = true
    },
    setChartData: function () {
      this.setBarLineChart()
    },
    setSearchPeriod: function (months, emit) {
      let fromDate = new Date(new Date().setMonth(new Date().getMonth() - months))
      let toDate = new Date()
      this.dateRange[0] = fromDate
      this.dateRange[1] = toDate
      emit(this.dateRange)
    },
    updateValues: function (dateRange) {
      if (Math.abs(moment(dateRange[0]).diff(moment(dateRange[1]), 'days')) > 90) {
        this.openAlert('최대 선택가능한 기간은 90일 입니다.')
        return false
      }
      this.setData()
      return true
    },
    headerSort: function (target) {
      if (document.querySelector('.statisticsData thead tr th.ascending') !== null) {
        document.querySelector('.statisticsData thead tr th.ascending').classList.remove('ascending')
      }
      if (document.querySelector('.statisticsData thead tr th.descending') !== null) {
        document.querySelector('.statisticsData thead tr th.descending').classList.remove('descending')
      }
      if (this.sortColumn === target) {
        if (this.sortType === 'asc') {
          this.sortType = 'desc'
          document.querySelector('.statisticsData thead tr th.' + target).classList.add('descending')
        } else {
          this.sortType = 'asc'
          document.querySelector('.statisticsData thead tr th.' + target).classList.add('ascending')
        }
      } else {
        document.querySelector('.statisticsData thead tr th.' + target).classList.add('ascending')
        this.sortColumn = target
        this.sortType = 'asc'
      }
    },
    confirmSelect02: function () {
      this.closeSelectAll()
      this.setChartData()
    },
    setLegend: function (html) {
      this.horizontalBarChartLegendHtml = html
    },
    downloadExcel: async function () {
      const table = document.querySelector('.statisticsData')
      const Excel = await exportExcel()
      Excel.default(table, '기간별 가동률')
    }
  },
  computed: {
    locationName () {
      const targetLocation = this.locationArr.find(location => location.code === this.selectedLocation)
      if (!targetLocation) return ''
      return targetLocation.name
    },
    computedUtilRatioStat () {
      const stats = []
      if (this.utilRatioDataSortByRegion === null) return []
      for (const updateAt in this.utilRatioDataSortByRegion) {
        const dateStat = {
          updateAt,
          allClubCount: 0,
          normalCount: 0,
          abnormalCount: 0,
          normalPercentage: 0
        }
        if (this.selectedLocation == 0) {
          for (const regionStat in this.utilRatioDataSortByRegion[updateAt]) {
            const { allClubCount, normalCount } = this.utilRatioDataSortByRegion[updateAt][regionStat] || {}
            dateStat.allClubCount += allClubCount || 0
            dateStat.normalCount += normalCount || 0
          }
        } else {
          const { allClubCount, normalCount } = this.utilRatioDataSortByRegion[updateAt][this.selectedLocation] || {}
          dateStat.allClubCount += allClubCount || 0
          dateStat.normalCount += normalCount || 0
        }
        dateStat.abnormalCount = dateStat.allClubCount - dateStat.normalCount
        dateStat.normalPercentage = Math.round(dateStat.normalCount / dateStat.allClubCount * 100) || 0
        stats.push(dateStat)
      }
      return stats.sort((a, b) => a.updateAt === b.updateAt ? 0 : a.updateAt > b.updateAt ? 1 : -1)
    },
    sortedComputedUtilRatioStat () {
      const stats = [...this.computedUtilRatioStat]
      stats.sort(this.sortType === 'asc' ? this.ascSort : this.descSort)
      return stats
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/states/ST002.vue